import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage"
import "firebase/analytics";

export let firebaseApp;
export let fireStoreDb;
export let cloudStorage;
export let analytics;

const firebaseConfig = {
    apiKey: "AIzaSyCjj-G9RDVQA0RVp8rz2jDL11Y7EzCce9w",
    authDomain: "kormanik-web.firebaseapp.com",
    databaseURL: "https://kormanik-web-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "kormanik-web",
    storageBucket: "kormanik-web.appspot.com",
    messagingSenderId: "721399658264",
    appId: "1:721399658264:web:8a2568ecf17487cd80d06d",
    measurementId: "G-DS791XZ73E"
};


export const initFireBase = () => {
    firebaseApp = firebase.initializeApp(firebaseConfig);
    fireStoreDb = firebase.firestore();
    cloudStorage = firebase.storage();
    analytics = firebase.analytics();
    analytics.logEvent('DEMO event: firebase initialized')
}

export const getAuth = () => {
    return firebase.auth();
}